import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.module.scss';

export default function Block({theme, className, ...props}) {

    const _className = classNames(
        styles.block,
        styles[`block--theme-${theme}`],
        className,
    );

    return <div className={_className} {...props} />;
}

const THEMES = [
    'default',  // Transparent
    'dark',
    'darker',
];

Block.propTypes = {
    theme: PropTypes.oneOf(THEMES).isRequired,
};


Block.defaultProps = {
    theme: 'default',
};



// WEBPACK FOOTER //
// ./src/ui/block/index.js